import { IconButton, Menu, MenuButton, MenuItem, MenuList, useToast } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MoreIcon from '@/assets/icons/ic-more.svg';

import { useStores } from '@/hooks/useStores';
import { useMutation } from '@/lib/datx-jsonapi-react';
import { IConversationMessage } from '@/utils/conversation/types';

interface INestedChatMessageMenuProps {
  message: IConversationMessage;
}
export const NestedChatMessageMenu: FC<INestedChatMessageMenuProps> = ({ message }) => {
  const { store } = useStores();
  const toast = useToast();
  const { t } = useTranslation();

  const deleteChatMessage = () => {
    return store.request(`chat_messages/${message.sid}?channel_id=${message.conversation.sid}`, 'DELETE');
  };

  const [deleteMessageMutation, { status }] = useMutation(deleteChatMessage, {
    onSuccess: () => {
      toast({ title: t('conversation.successDeletingMessage'), status: 'success', isClosable: true });
    },
    onFailure: () => {
      toast({ title: t('conversation.errorDeletingMessage'), status: 'error', isClosable: true });
    },
  });

  return (
    <Menu isLazy placement="bottom" flip={false} offset={[-30, 0]}>
      <MenuButton
        isLoading={status === 'running'}
        as={IconButton}
        icon={<MoreIcon />}
        size="xs"
        variant="unstyled"
        display="flex"
      />
      <MenuList minW="max-content" willChange="transform">
        <MenuItem
          p={1}
          fontSize="sm"
          _hover={{
            color: 'red.600',
          }}
          onClick={deleteMessageMutation}
        >
          {t('conversation.deleteMessage')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
